import { clearDelayTimeout as clearTimeout, setDelayTimeout as setTimeout } from "./delay.timeouts";

/**
 * Creates a promise that will complete after a time delay, specified in milliseconds.
 * @returns Aborted flag.
 *  - True when the delay was canceled due to an abort signal
 *  - False when the delay ran its course without cancellation
 */
export function delay(duration: number, signal?: AbortSignal) {
    return new Promise<boolean>((resolve) => {
        const timer = setTimeout(() => resolve(false), duration);
        signal?.addEventListener("abort", () => {
            clearTimeout(timer);
            resolve(true);
        });
    });
}
